import FAQItem from '@/components/faq/FAQItem';
import { sendAnalyticsEvent } from '@/utils/Analytics';
import { FAQDataItem } from '@/utils/faq/FaqFormatter';
import { useElementVisibility } from '@/utils/hooks/UseElementVisibility';

interface FAQWidgetProps {
  faqData: FAQDataItem[];
}

const FAQWidget = ({ faqData }: FAQWidgetProps) => {
  const faqRef = useElementVisibility(() => {
    sendAnalyticsEvent('faq_show');
  });

  return (
    <div ref={faqRef} className="my-6 lg:my-14">
      <h2 className="mb-4 px-4 text-lg font-medium leading-6 text-grey-900 lg:mb-5 lg:px-0 lg:text-xl">FAQ</h2>
      <div className="flex flex-col gap-3 px-4 md:flex-row lg:px-0">
        <div className="flex flex-1 flex-col gap-3">
          {faqData.slice(0, 2).map((item, index) => (
            <FAQItem key={index} question={item.question} answer={item.answer} />
          ))}
        </div>
        <div className="flex flex-1 flex-col gap-3">
          {faqData.slice(2).map((item, index) => (
            <FAQItem key={index + 2} question={item.question} answer={item.answer} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQWidget;
